import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLanguageState } from "./selectedLanguage";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import clsx from "clsx";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: "20px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    backgroundColor: "transparent",
    border: "0",
    "&:hover": {},
    "&:focus": { outline: 0 },
  },
  active: {
    color: colors.LANGUAGE_ACTIVE,
  },
  inactive: {
    color: colors.LANGUAGE_INACTIVE,
  },
  pipe: {
    color: colors.LANGUAGE_INACTIVE,
    fontSize: "18px",
  },
}));

export function LanguageSelection() {
  const { i18n } = useTranslation();
  const classes = useStyles();
  const [language, setLanguage] = useLanguageState<string>("en");

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [i18n, language]);

  const activeButton = clsx(classes.button, classes.active);
  const inactiveButton = clsx(classes.button, classes.inactive);

  return (
    <Grid item container direction="row" justify="center">
      <Grid item>
        <button
          onClick={() => setLanguage("en")}
          className={language === "en" ? activeButton : inactiveButton}
        >
          EN
        </button>
      </Grid>
      <Grid item>
        <span className={classes.pipe}>|</span>
      </Grid>
      <Grid item>
        <button
          onClick={() => setLanguage("nl")}
          className={language === "nl" ? activeButton : inactiveButton}
        >
          NL
        </button>
      </Grid>
    </Grid>
  );
}
